export const mailRuTokenParam = 'mailrutoken'
